const e = (...t) => (c) => {
  t.forEach((n) => {
    n instanceof Function ? n(c) : n !== null && (n.current = c);
  });
};
export {
  e as mergeRefs
};
